<template>
  <div class="top_banner" v-show="dataModal.img">
    <van-image
      width="100%"
      height="100%"
      block
      :src="dataModal.img"
      @click="onClick(dataModal)"
    />
    <div class="sub_title" v-show="dataModal.title">{{ dataModal.title }}</div>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Image as VanImage } from "vant";
import "../plugins/bridge.js";
import { useStore } from "vuex";

export default {
  name: "Slide",
  props: {
    dataModal: {},
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [VanImage.name]: VanImage,
  },
  setup() {
    const store = useStore();
    const onClick = (item) => {
      const userAgentString = navigator.userAgent.toLocaleLowerCase();
      if (item.url) {
        if (userAgentString.indexOf("zsrbapp") < 0) {
          window.open(item.url, "_blank");
          // window.location.href = item.url;
        } else {
          store
            .dispatch("getViewInfoBridging", {
              id: item.id,
            })
            .then((res) => {
              window.ZsrbApp.call("viewInfo", res);
            });
        }
      }
    };
    return { onClick };
  },
};
</script>

<style lang="scss" scoped>
.top_banner {
  position: relative;
  margin-bottom: 10px;
  .sub_title {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 36px;
    line-height: 36px;
    background-color: rgba(0, 0, 0, 0.4);
    width: 100%;
    box-sizing: border-box;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    text-align: left;
    padding: 0 11px;
    width: 100vw;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
